G.CandySelection = function(board) {
  G.Image.call(this, 0, 0, null, 0.5);
  this.board = board;
  this.alpha = 0;
  game.add.existing(this);

  this.selection = G.makeImage(0, 0, "selected_cookie_new", 0.5, this);
  game.add.tween(this.selection.scale)
    .to({x: 1.2, y: 1.2}, 800, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

  this.frameIndex = 0;
  this.every = 3;
  this.frameCounter = 0;

  this.scale = this.board.scale;
};

G.CandySelection.prototype = Object.create(G.Image.prototype);


G.CandySelection.prototype.selectCandy = function(candy) {
  this.alpha = 1;
  this.x = this.board.boardCandies.x+(candy.x*this.board.scale.x);
  this.y = this.board.boardCandies.y+(candy.y*this.board.scale.y);
};

G.CandySelection.prototype.hide = function() {
  this.alpha = 0;
};